import { CORE_SECTOR } from './runConstants';

const encounter = (game) =>
  game.guardian?.active
    ? `guardian:${game.floor}:${game.guardian.round}`
    : game.floor === CORE_SECTOR
    ? `core:${game.bossRound}`
    : game.miniBoss?.active
    ? `warden:${game.miniBoss.round}`
    : `room:${game.roomId}`;

export const getThrowCombo = (game) =>
  game.throwCombo?.floor === game.floor &&
  game.throwCombo.encounter === encounter(game)
    ? game.throwCombo
    : null;

export const startThrowCombo = (game) => ({
  ...game,
  throwCombo: { floor: game.floor, encounter: encounter(game), events: [] },
});

export const recordThrowEvent = (game, type, details = {}) => {
  if (
    !['rolled', 'bossPlayerRolled', 'bossRolled'].includes(game.phase) ||
    Number.isInteger(game.landingIndex) ||
    !['bump', 'anchor', 'portal', 'chain'].includes(type)
  )
    return game;
  const combo = getThrowCombo(game) || startThrowCombo(game).throwCombo;
  const count = combo.events.filter((event) => event.type === type).length;
  if (count >= (type === 'bump' ? 3 : 1)) return game;
  return {
    ...game,
    throwCombo: { ...combo, events: [...combo.events, { type, ...details }] },
  };
};

export const isLinkedThrow = (combo) =>
  new Set((combo?.events || []).map(({ type }) => type)).size >= 2;
